// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
import { Strings as en_us } from './strings.en-us.js';
// UK English is identical to US English for the vast majority of strings, so we
// start from the en-US copy and only override the keys that differ (spelling or
// UK-specific terminology). Any key not overridden here renders the en-US text.
export const Strings = {
    ...en_us,
    // UK spellings
    CUSTOMIZE: `Customise`,
    FAVORITE: `Favourite`,
    FAVORITES: `Favourites`,
    FAVORITES_NONE_YET: `No favourites yet.`,
    FAVORITES_REMOVE_CONFIRMATION: `Are you sure you want to remove this favourite?`,
    SIGNUP_BENEFITS: `Create an account to save your credit card and favourite items for easy checkout.`,
    // UK address / postcode terminology
    ADDRESS_LINE_2: `Flat, Floor, Suite, Building, Company (Optional)`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `Address, Town, or Postcode`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `Please enter a valid postcode`,
};
//# sourceMappingURL=strings.en-gb.js.map